export default {
    isSearchFormOpen: state => state.searchFormIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getHeaderFields: state => state.headerFields
}
